<template>
  <svg
    width="1600px"
    height="900px"
    viewBox="0 0 1600 900"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid slice"
  >
    <defs>
      <path
        d="M7.99994872,2 C3.58159661,2 0,5.50116672 0,9.81995368 C0,11.7441807 2.38677377,15.8000604 2.38677377,15.8000604 L7.99994872,25 L13.2905451,15.8000604 C13.2905451,15.8000604 16,11.7153827 16,9.81995368 C16,5.50116672 12.4183008,2 7.99994872,2"
        id="path-1"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-3"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-5"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-6"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M-6.99406864,15.6223824 C-6.99198465,15.6423967 -6.98958005,15.6627391 -6.98669452,15.6829174 C-6.98284716,15.7127748 -6.97803795,15.7431243 -6.97178597,15.7728176 L-6.93860243,15.8958563 C-6.93507568,15.907832 -6.93122831,15.9196437 -6.92722064,15.9314554 L-6.89067065,16.0259491 C-6.88361715,16.041534 -6.87624303,16.0567908 -6.86838798,16.0720476 C-6.85796803,16.0943586 -6.84402133,16.1217552 -6.82590664,16.1521047 C-6.81244085,16.1757281 -6.79849415,16.1982032 -6.78374591,16.2201861 C-6.77524964,16.2333102 -6.76707398,16.2451219 -6.75969986,16.255129 L-6.73597443,16.2881034 C-6.72026435,16.309102 -6.70407335,16.3289522 -6.68740142,16.3481462 L0.415960368,23.6225175 C0.653374979,23.8659699 0.969179694,24 1.30534339,24 C1.64150709,24 1.95731181,23.8659699 2.19312335,23.623994 C2.43166011,23.3807056 2.5627912,23.056868 2.56247059,22.7123598 C2.56231028,22.5084438 2.51614188,22.3117461 2.42877458,22.1348986 L2.42877458,22.0440141 L-2.70890324,16.7859997 L22.7430331,16.7859997 C23.4360401,16.7859997 24,16.2088665 24,15.4996719 C24,14.7904773 23.4360401,14.2133441 22.7430331,14.2133441 L-2.70906355,14.2133441 L2.19216151,9.19681354 C2.43053796,8.95450949 2.56198967,8.6318202 2.56247059,8.28796827 C2.56311182,7.94362419 2.43214103,7.61978654 2.19392488,7.37617007 C1.94897585,7.12549939 1.62707947,7 1.30534339,7 C0.98360732,7 0.661710941,7.12549939 0.416761903,7.37617007 L-6.63273675,14.5903345 L-6.66768367,14.6283944 C-6.67201196,14.63348 -6.67650055,14.6387297 -6.68098915,14.6441434 C-6.70375273,14.6702275 -6.7260354,14.6976241 -6.74655469,14.725841 L-6.75344789,14.73552 C-6.76835644,14.7558624 -6.78246345,14.776861 -6.79544832,14.7978596 C-6.80538735,14.8134445 -6.81500577,14.8290294 -6.8249448,14.8457626 C-6.84434194,14.8784089 -6.86133448,14.9112192 -6.87271627,14.935991 C-6.88201408,14.9550209 -6.89115157,14.974215 -6.90060968,14.9968541 L-6.93411384,15.0903634 C-6.93796121,15.1021751 -6.94116734,15.1131666 -6.94405287,15.1226816 L-6.97178597,15.2265262 C-6.97787764,15.2553992 -6.98268685,15.2849285 -6.98653422,15.3157702 C-6.98974035,15.337425 -6.99214496,15.3580955 -6.99390834,15.3764692 C-6.99823662,15.4166618 -7,15.4575107 -7,15.4996719 C-7,15.5400286 -6.99855724,15.5780885 -6.99406864,15.6223824"
        id="path-7"
      ></path>
      <filter
        x="-44.7%"
        y="-79.4%"
        width="188.2%"
        height="258.8%"
        filterUnits="objectBoundingBox"
        id="filter-8"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="3.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-9"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-10"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-11"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-12"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-13"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-14"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-15"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-16"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 0.823529412   0 0 0 0 0  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-17"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-18"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-19"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-20"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-21"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-22"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-23"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-24"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-25"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-26"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-27"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-28"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-29"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-30"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-31"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-32"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-33"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-34"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M186.999949,0 C182.581597,0 179,3.50116672 179,7.81995368 C179,9.74418065 181.386774,13.8000604 181.386774,13.8000604 L186.999949,23 L192.290545,13.8000604 C192.290545,13.8000604 195,9.7153827 195,7.81995368 C195,3.50116672 191.418301,0 186.999949,0"
        id="path-35"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-36"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-37"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-38"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-39"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-40"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M7.99994872,0 C3.58159661,0 0,3.50116672 0,7.81995368 C0,9.74418065 2.38677377,13.8000604 2.38677377,13.8000604 L7.99994872,23 L13.2905451,13.8000604 C13.2905451,13.8000604 16,9.7153827 16,7.81995368 C16,3.50116672 12.4183008,0 7.99994872,0"
        id="path-41"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-42"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
      <path
        d="M144.999949,0 C140.581597,0 137,3.50116672 137,7.81995368 C137,9.74418065 139.386774,13.8000604 139.386774,13.8000604 L144.999949,23 L150.290545,13.8000604 C150.290545,13.8000604 153,9.7153827 153,7.81995368 C153,3.50116672 149.418301,0 144.999949,0"
        id="path-43"
      ></path>
      <filter
        x="-103.1%"
        y="-71.7%"
        width="306.2%"
        height="251.8%"
        filterUnits="objectBoundingBox"
        id="filter-44"
      >
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        ></feMorphology>
        <feOffset
          dx="0"
          dy="0"
          in="shadowSpreadOuter1"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="4.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      id="Casinos"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="casino-map-pins">
        <g
          id="lvcc"
          transform="translate(823, 252)"
          v-if="whereWeAreVenueArr.indexOf('14') !== -1"
        >
          <router-link to="/venue/whereweare/conventioncenter">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-2)"
                xlink:href="#path-1"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-1"
              ></use>
            </g>
            <text
              id="Las-Vegas-Convention"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="13"
              fill="#FFFFFF"
            >
              <tspan x="22" y="11">Las Vegas</tspan>
              <tspan x="22" y="24">Convention Center</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="mgm"
          transform="translate(631, 603)"
          v-if="whereWeAreVenueArr.indexOf('18') !== -1"
        >
          <router-link to="/venue/whereweare/mgm">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-4)"
                xlink:href="#path-3"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-3"
              ></use>
            </g>
            <text
              id="MGM-Grand"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">MGM Grand</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="mandalay"
          transform="translate(583, 732)"
          v-if="whereWeAreVenueArr.indexOf('17') !== -1"
        >
          <router-link to="/venue/whereweare/mandalaybay">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-6)"
                xlink:href="#path-5"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-5"
              ></use>
            </g>
            <text
              id="Mandalay-Bay"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Mandalay Bay</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="m"
          transform="translate(719, 751)"
          v-if="whereWeAreVenueArr.indexOf('16') !== -1"
        >
          <router-link to="/venue/whereweare/spacasino">
            <g
              id="top-left-arrow"
              transform="translate(8.5, 15.5) rotate(-90) translate(-8.5, -15.5)"
            >
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-8)"
                xlink:href="#path-7"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-7"
              ></use>
            </g>
            <text
              id="M-Resort-Spa-Casino"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="25" y="14">M Resort Spa Casino</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="nyny"
          transform="translate(453, 607)"
          v-if="whereWeAreVenueArr.indexOf('19') !== -1"
        >
          <router-link to="/venue/whereweare/newyork">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-10)"
                xlink:href="#path-9"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-9"
              ></use>
            </g>
            <text
              id="New-York,-New-York"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="16.4667969" y="14">New York, New York</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="park"
          transform="translate(457, 580)"
          v-if="whereWeAreVenueArr.indexOf('20') !== -1"
        >
          <router-link to="/venue/whereweare/parkmgm">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-12)"
                xlink:href="#path-11"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-11"
              ></use>
            </g>
            <text
              id="Park-MGM"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="73.2324219" y="14">Park MGM</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="luxor"
          transform="translate(438, 688)"
          v-if="whereWeAreVenueArr.indexOf('15') !== -1"
        >
          <router-link to="/venue/whereweare/luxor">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-14)"
                xlink:href="#path-13"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-13"
              ></use>
            </g>
            <text
              id="Luxor"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="98.6328125" y="14">Luxor</tspan>
            </text>
          </router-link>
        </g>
        <g id="STADIUM" transform="translate(373, 714)">
          <g id="Fill-1">
            <use
              fill="black"
              fill-opacity="1"
              filter="url(#filter-16)"
              xlink:href="#path-15"
            ></use>
            <use fill="#FFD200" fill-rule="evenodd" xlink:href="#path-15"></use>
          </g>
          <text
            id="Allegiant-Stadium"
            font-family="ArtegraSans-Regular, Artegra Sans"
            font-size="12"
            font-weight="normal"
            line-spacing="20"
            fill="#FFFFFF"
          >
            <tspan x="32.234375" y="14">Allegiant Stadium</tspan>
          </text>
        </g>
        <g
          id="bellagio"
          transform="translate(431.000000, 483.000000)"
          v-if="whereWeAreVenueArr.indexOf('11') !== -1"
        >
          <router-link to="/venue/whereweare/bellagio">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-18)"
                xlink:href="#path-17"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-17"
              ></use>
            </g>
            <text
              id="Bellagio"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="86.4863281" y="14">Bellagio</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="Aria"
          transform="translate(441.000000, 544.000000)"
          v-if="whereWeAreVenueArr.indexOf('118') !== -1"
        >
          <router-link to="/venue/whereweare/aria">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-20)"
                xlink:href="#path-19"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-19"
              ></use>
            </g>
            <text
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="108.271484" y="14">Aria</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="waldorf"
          transform="translate(675.000000, 317.000000)"
          v-if="whereWeAreVenueArr.indexOf('999') !== -1"
        >
          <router-link to="/venue/whereweare/waldorf">
            <g id="pin">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-22)"
                xlink:href="#path-21"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-21"
              ></use>
            </g>
            <text
              id="Waldorf-Astoria"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="41.1757812" y="14">Waldorf Astoria</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="vdara"
          transform="translate(408, 525)"
          v-if="whereWeAreVenueArr.indexOf('999') !== -1"
        >
          <router-link to="/venue/whereweare/vdara">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-24)"
                xlink:href="#path-23"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-23"
              ></use>
            </g>
            <text
              id="Vdara"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="97.3203125" y="14">Vdara</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="cosmo"
          transform="translate(420, 506)"
          v-if="whereWeAreVenueArr.indexOf('141') !== -1"
        >
          <router-link to="/venue/whereweare/cosmopolitan">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-26)"
                xlink:href="#path-25"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-25"
              ></use>
            </g>
            <text
              id="The-Cosmopolitan"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="28.71875" y="14">The Cosmopolitan</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="wynn"
          transform="translate(675, 317)"
          v-if="whereWeAreVenueArr.indexOf('13') !== -1"
        >
          <router-link to="/venue/whereweare/encorewynn">
            <g id="pin">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-28)"
                xlink:href="#path-27"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-27"
              ></use>
            </g>
            <text
              id="Encore-&amp;-Wynn"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Wynn &amp; Encore</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="wynn"
          transform="translate(649.000000, 285.000000)"
          v-if="whereWeAreVenueArr.indexOf('120') !== -1"
        >
          <router-link to="/venue/whereweare/resortworld">
            <g id="pin">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-30)"
                xlink:href="#path-29"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-29"
              ></use>
            </g>
            <text
              id="Resorts-World-Las-Ve"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Resorts World Las Vegas</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="fontainbleau"
          transform="translate(758.000000, 196.000000)"
          v-if="whereWeAreVenueArr.indexOf('139') !== -1"
        >
          <router-link to="/venue/whereweare/fontainebleau">
            <g id="pin">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-32)"
                xlink:href="#path-31"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-31"
              ></use>
            </g>
            <text
              id="Fontainebleau"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Fontainebleau</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="venetian"
          transform="translate(638.000000, 379.000000)"
          v-if="whereWeAreVenueArr.indexOf('22') !== -1"
        >
          <router-link to="/venue/whereweare/venetian">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-34)"
                xlink:href="#path-33"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-33"
              ></use>
            </g>
            <text
              id="The-Venetian-&amp;-The-P"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Venetian &amp; Palazzo</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="harrahs"
          transform="translate(438, 403)"
          v-if="whereWeAreVenueArr.indexOf('138') !== -1"
        >
          <router-link to="/venue/whereweare/harrahs">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-36)"
                xlink:href="#path-35"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-35"
              ></use>
            </g>
            <text
              id="Harrah’s-Las-Vegas"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="65.7089844" y="14">Harrah’s Las Vegas</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="caesars-forum"
          transform="translate(665, 409)"
          v-if="whereWeAreVenueArr.indexOf('142') !== -1"
        >
          <router-link to="/venue/whereweare/casesarsforum">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-38)"
                xlink:href="#path-37"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-37"
              ></use>
            </g>
            <text
              id="Caesars-Forum"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Caesars Forum</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="waldorf"
          transform="translate(420, 563)"
          v-if="whereWeAreVenueArr.indexOf('152') !== -1"
        >
          <router-link to="/venue/whereweare/waldorfastoria">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-24)"
                xlink:href="#path-23"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-23"
              ></use>
            </g>
            <text
              id="Waldorf-Astoria"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="41.1757812" y="14">Waldorf Astoria</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="four-seasons"
          transform="translate(571, 749)"
          v-if="whereWeAreVenueArr.indexOf('151') !== -1"
        >
          <router-link to="/venue/whereweare/fourseasons">
            <!-- <g id="Fill-1">
            <use
              fill="black"
              fill-opacity="1"
              filter="url(#filter-8)"
              xlink:href="#path-7"
            ></use>
            <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-7"></use>
          </g> -->
            <text
              id="Four-Seasons"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Four Seasons</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="planet-hollywood"
          transform="translate(608, 454)"
          v-if="whereWeAreVenueArr.indexOf('999') !== -1"
        >
          <router-link to="/venue/whereweare/planethollywood">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-40)"
                xlink:href="#path-39"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-39"
              ></use>
            </g>
            <text
              id="Planet-Hollywood"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Planet Hollywood</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="paris"
          transform="translate(628, 484)"
          v-if="whereWeAreVenueArr.indexOf('137') !== -1"
        >
          <router-link to="/venue/whereweare/paris">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-42)"
                xlink:href="#path-41"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-41"
              ></use>
            </g>
            <text
              id="Paris-Las-Vegas"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="22" y="14">Paris Las Vegas</tspan>
            </text>
          </router-link>
        </g>
        <g
          id="caesars"
          transform="translate(453, 441)"
          v-if="whereWeAreVenueArr.indexOf('12') !== -1"
        >
          <router-link to="/venue/whereweare/caesarspalace">
            <g id="Fill-1">
              <use
                fill="black"
                fill-opacity="1"
                filter="url(#filter-44)"
                xlink:href="#path-43"
              ></use>
              <use
                fill="#FFFFFF"
                fill-rule="evenodd"
                xlink:href="#path-43"
              ></use>
            </g>
            <text
              id="Caesars-Palace"
              font-family="ArtegraSans-Regular, Artegra Sans"
              font-size="12"
              font-weight="normal"
              line-spacing="20"
              fill="#FFFFFF"
            >
              <tspan x="46.0976562" y="14">Caesars Palace</tspan>
            </text>
          </router-link>
        </g>
        <rect
          id="Rectangle"
          fill="#000000"
          x="1599"
          y="899"
          width="1"
          height="1"
        ></rect>
        <rect
          id="Rectangle"
          fill="#000000"
          x="0"
          y="0"
          width="1"
          height="1"
        ></rect>
        <rect
          id="Rectangle"
          fill="#000000"
          x="1599"
          y="0"
          width="1"
          height="1"
        ></rect>
        <rect
          id="Rectangle"
          fill="#000000"
          x="0"
          y="899"
          width="1"
          height="1"
        ></rect>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "WhereWeArePins",
  props: ["whereWeAreVenueArr"],
};
</script>

<style lang="scss" scoped>
svg {
  background-image: url("~@/assets/images/VenueOverview/WhereWeAre/bg-casino-map-all.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
